import LinearProgress from "@mui/material/LinearProgress";
import styles from "./Loader.module.css";
const Loader = () => {
  return <LinearProgress className={styles.loader} />;
};

export default Loader;
